import Splide from "@splidejs/splide";

/** SP では .spItem と重複になるためリストから除外（768px と _define の mq 準拠） */
const SEC03_HIDE_FIRST_SLIDE_MQ = "(max-width: 768px)";
const SEC03_FIRST_SLIDE_IN_LIST =
  ".splide__slide.is-first:not(.splide__slide--clone)";
const SEC03_USER_SLIDE = ".splide__slide:not(.splide__slide--clone)";

/**
 * @param {HTMLElement} root
 * @param {{ el: HTMLElement | null }} detachedRef
 * @param {MediaQueryList} mq
 */
function syncSec03FirstSlideInDom(root, detachedRef, mq) {
  const list = root.querySelector(".splide__list");
  if (!list) return;

  if (mq.matches) {
    const live = list.querySelector(SEC03_FIRST_SLIDE_IN_LIST);
    if (live) {
      detachedRef.el = live;
      live.remove();
    }
  } else if (detachedRef.el) {
    const anchor = list.querySelector(SEC03_USER_SLIDE);
    if (anchor) {
      list.insertBefore(detachedRef.el, anchor);
    } else {
      list.appendChild(detachedRef.el);
    }
    detachedRef.el = null;
  }
}

/** @param {MediaQueryList} mql */
function onMediaQueryChange(mql, handler) {
  if (typeof mql.addEventListener === "function") {
    mql.addEventListener("change", handler);
  } else {
    mql.addListener(handler);
  }
}

const pickUpSplideOptions = {
  type: "slide",
  perPage: 1,
  perMove: 1,
  gap: "25px",
  speed: 800,
  autoWidth: true,
  autoplay: false,
  pagination: false,
  arrows: false,
  breakpoints: {
    768: {
      perPage: 1,
      gap: "10px",
    },
  },
};

document.addEventListener("DOMContentLoaded", () => {
  const root03 = document.querySelector(".js-sec03-splide");
  if (root03) {
    const bar = root03.querySelector(".splide__progress__bar");
    const sec03Mq = window.matchMedia(SEC03_HIDE_FIRST_SLIDE_MQ);
    const detachedFirstSlide = { el: /** @type {HTMLElement|null} */ (null) };
    let prevMatches = sec03Mq.matches;

    syncSec03FirstSlideInDom(root03, detachedFirstSlide, sec03Mq);

    const splide = new Splide(root03, pickUpSplideOptions);

    const syncProgress = () => {
      if (!bar) return;
      const n = splide.length;
      if (!n) return;
      const pct = ((splide.index + 1) / n) * 100;
      bar.style.width = `${pct}%`;
    };

    const onSec03ViewportChange = () => {
      if (prevMatches === sec03Mq.matches) return;
      prevMatches = sec03Mq.matches;

      syncSec03FirstSlideInDom(root03, detachedFirstSlide, sec03Mq);
      splide.refresh();
      window.requestAnimationFrame(() => {
        splide.go(0);
        syncProgress();
      });
    };

    splide.on("mounted moved updated refresh resized", syncProgress);
    splide.mount();
    syncProgress();

    onMediaQueryChange(sec03Mq, onSec03ViewportChange);
  }

  const sec10SplideOptions = {
    type: "loop",
    perPage: 1,
    perMove: 1,
    gap: "25px",
    speed: 800,
    autoWidth: true,
    autoplay: true,
    pagination: false,
    arrows: false,
    breakpoints: {
      768: {
        perPage: 1,
      },
    },
  };

  const root10 = document.querySelector(".js-sec10-splide");
  if (root10) {
    new Splide(root10, { ...sec10SplideOptions, gap: "1px" }).mount();
  }
});
